import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {

    public transform(value: any): any {
        value = value.toString();

        if (value.charAt(0) === '0') value = value.slice(1);

        const phoneArea = value.substr(0, 2);
        const first = value.slice(2, value.length - 4);
        const last = value.substr(value.length - 4);

        if (value.includes('null') || value.includes('undefined')) {
            return ``;
        } else {
            return `(${phoneArea}) ${first}-${last}`;
        }

    }

}
